import deepmerge from 'deepmerge';

function arrayMergeById(destinationArray: any[], sourceArray: any[], options?: deepmerge.Options) {
  const sourceMap = sourceArray.reduce((map, obj) => {
    map[obj.id] = obj;
    return map;
  }, {});

  return destinationArray
    .map(obj => {
      const sourceObj = sourceMap[obj.id];
      if (sourceObj) {
        delete sourceMap[obj.id];
        return deepmerge(obj, sourceObj, options);
      } else {
        return obj;
      }
    })
    .concat(Object.values(sourceMap));
}

type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;

export default function <T>(destination: T, source: DeepPartial<T>): T {
  // @ts-ignore -> library typings are wrong
  return deepmerge(destination, source, { arrayMerge: arrayMergeById });
}
